import { motion } from 'framer-motion';
import { useInView } from '../hooks/useInView';

export default function MarketingCampaigns() {
  const [ref, isInView] = useInView({ threshold: 0.1 });

  const metrics = [
    { number: '250%', label: 'ROI Medio' },
    { number: '1.5M+', label: 'Reach Totale' },
    { number: '98%', label: 'Soddisfazione Clienti' },
  ];

  return (
    <section id="marketing" ref={ref} className="py-24 md:py-32 bg-white px-4">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8 }}
          className="text-center mb-16"
        >
          <div className="inline-block bg-primary/10 text-primary px-4 py-2 rounded-full text-xs font-bold uppercase mb-6 whitespace-nowrap">
            Campagne di Marketing
          </div>
          <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl font-bold text-dark max-w-3xl mx-auto leading-tight">
            Strategie che Generano Risultati
          </h2>
        </motion.div>

        {/* Bento Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
          {/* Large Featured Case Study */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={isInView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.6 }}
            className="lg:col-span-2 lg:row-span-2 relative h-[500px] rounded-3xl overflow-hidden group cursor-pointer"
          >
            <div className="w-full h-full">
              <img
                src="https://public.readdy.ai/ai/img_res/5ba9b605db8a4df381e15daee16f8a0e.jpg"
                alt="Case Study Marketing"
                className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
            </div>
            <div className="absolute inset-0 bg-gradient-to-t from-black via-black/50 to-transparent"></div>
            <div className="absolute bottom-0 left-0 right-0 p-8">
              <div className="inline-block bg-primary px-4 py-2 rounded-full text-xs font-bold uppercase mb-4 whitespace-nowrap">
                CASE STUDY
              </div>
              <h3 className="text-3xl md:text-4xl font-bold text-white mb-4">
                Campagna Digitale Automotive
              </h3>
              <div className="flex gap-8 mb-6">
                <div>
                  <div className="text-4xl font-black text-white">+350%</div>
                  <div className="text-white/80 text-sm">Lead Generation</div>
                </div>
                <div>
                  <div className="text-4xl font-black text-white">2.8M</div>
                  <div className="text-white/80 text-sm">Impressions</div>
                </div>
              </div>
              <button className="border-2 border-white text-white px-6 py-3 rounded-full font-semibold text-sm hover:bg-white hover:text-dark transition-all whitespace-nowrap">
                LEGGI IL CASO
              </button>
            </div>
          </motion.div>

          {/* Service Block 1 */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={isInView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.6, delay: 0.1 }}
            className="bg-gradient-to-br from-primary to-primary/80 rounded-3xl p-8 flex flex-col items-center justify-center text-center h-[240px] hover:scale-105 transition-transform duration-300 cursor-pointer"
          >
            <div className="w-16 h-16 flex items-center justify-center mb-4">
              <i className="ri-line-chart-line text-white text-5xl"></i>
            </div>
            <h3 className="text-xl font-bold text-white mb-3">
              Strategia Digitale
            </h3>
            <p className="text-white/90 text-sm">
              Pianificazione e implementazione di strategie digitali integrate
            </p>
          </motion.div>

          {/* Service Block 2 */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={isInView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="bg-gradient-to-br from-primary to-primary/80 rounded-3xl p-8 flex flex-col items-center justify-center text-center h-[240px] hover:scale-105 transition-transform duration-300 cursor-pointer"
          >
            <div className="w-16 h-16 flex items-center justify-center mb-4">
              <i className="ri-megaphone-line text-white text-5xl"></i>
            </div>
            <h3 className="text-xl font-bold text-white mb-3">
              Social Media
            </h3>
            <p className="text-white/90 text-sm">
              Gestione completa dei canali social con contenuti creativi
            </p>
          </motion.div>
        </div>

        {/* Metrics Row */}
        <div className="grid md:grid-cols-3 gap-6">
          {metrics.map((metric, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              animate={isInView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.6, delay: 0.3 + index * 0.1 }}
              className="bg-gray-light rounded-3xl p-8 text-center relative overflow-hidden group hover:bg-primary transition-colors duration-300 cursor-pointer"
            >
              <div className="text-5xl md:text-6xl font-black text-dark mb-2 group-hover:text-white transition-colors">
                {metric.number}
              </div>
              <div className="text-gray-dark text-sm font-semibold uppercase group-hover:text-white transition-colors">
                {metric.label}
              </div>
              <div className="absolute bottom-4 right-4 w-12 h-12 flex items-center justify-center">
                <i className="ri-arrow-right-up-line text-primary text-2xl group-hover:text-white transition-colors"></i>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}